<div *ngIf="isOffline$ | async">
    <span>No Internet Connection.</span>
</div>
